<template>
  <div></div>
</template>


<script>
export default {
  mounted() {
    localStorage.removeItem('user');
    this.$router.push('/pages/login').catch(() => {});
  }
};
</script>
